import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

import { getGaLabelByNavigationType } from '~/src/features/specialOffersContainer/helpers';

export class SpecialOfferAnalytics extends BaseAnalytics {
    constructor(category = 'VAS') {
        super();

        this.category = category;
    }

    private getLabel(offer: ISpecOffer) {
        return `discounts:${offer.title}${getGaLabelByNavigationType(offer)}`;
    }

    view(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('view_promo_after_payment', label);
    }

    viewOffersList(label: string) {
        this.send('view_special_offer_list', label);
    }

    showPromoDetails(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('click_promo_details_btn', label);
    }

    showAllPromo(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('click_promo_list_btn', label);
    }

    instantConnect(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('click_promo_action_btn', label);
    }

    connectWithPhone(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('subscription_phone_click_connect', label);
    }

    successPhoneCheck(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('subscription_phone_check_success', label);
    }

    errorPhoneCheck(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('subscription_phone_check_error', label);
    }

    refillBalance(label: string) {
        this.send('click_refill_balance_and_connect', label);
    }

    showOfferDetails(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('click_offer_details', label);
    }

    showOfferWithNewDesign(label: string) {
        this.send('open_promo_with_available_new_design', label);
    }

    successConnected(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('send_promo_popup_success', label);
    }

    successDisconnected(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('disconnect_promo_popup_success', label);
    }

    connectionError(offer: ISpecOffer) {
        const label = this.getLabel(offer);
        this.send('send_promo_popup_error', label);
    }
}

export const specialOfferAnalytics = new SpecialOfferAnalytics();
